interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function Logo({ size = 'md', className = '' }: LogoProps) {
  const fontSize = size === 'sm' ? '18px' : size === 'lg' ? '40px' : '24px';
  return (
    <span
      className={className}
      style={{
        fontSize,
        letterSpacing: '-0.02em',
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'baseline',
        gap: '0.18em',
        color: 'var(--color-primary)',
      }}
    >
      <span style={{ fontWeight: 600 }}>menu</span>
      <span style={{ fontWeight: 300, opacity: 0.7 }}>to</span>
      <span style={{ fontWeight: 600 }}>menu</span>
    </span>
  );
}
